/** Платформа користувача: на Mac клавіша-модифікатор — ⌘ (Command), на інших — Ctrl. */
export const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

/** Підпис клавіші-модифікатора для підказок: «⌘» або «Ctrl». Самі обробники приймають і metaKey, і ctrlKey. */
export const MOD = isMac ? '⌘' : 'Ctrl';

/** Комбінація для підказки в атрибуті title: «⌘B» на Mac, «Ctrl+B» на інших. */
export function modKey(key: string, shift = false): string {
  return isMac ? `${shift ? '⇧' : ''}⌘${key}` : `Ctrl+${shift ? 'Shift+' : ''}${key}`;
}
